




















import { Component, Vue, Prop } from 'vue-property-decorator';
import { ALL_OCCUPATIONS } from '@/queries/Occupation';
import { GQL_occupationSelections_currentUnit_occupationSelections, GQL_occupationSelections } from '@/queries/__generated__/occupationSelections';
import { GQL_deleteOccupationSelection_deleteOccupationSelection_occupationSelection } from '@/queries/__generated__/deleteOccupationSelection';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { GQL_occupations } from '@/queries/__generated__/occupations';
import gql from 'graphql-tag';
import { OCCUPATION_SELECTIONS } from './occupationSelection';

const DELETE_OCCUPATION_SELECTION = gql`
  mutation deleteOccupationSelection($id: ID!) {
    deleteOccupationSelection(input: { id: $id }) {
      occupationSelection {
        id
        occupation {
          id
        }
      }
    }
  }
`;

interface IDeleteOccupationResponse {
  data: {
    deleteOccupationSelection: {
      occupationSelection: GQL_deleteOccupationSelection_deleteOccupationSelection_occupationSelection;
    };
  };
}

@Component
export default class OccupationSelectionDeleteButton extends Vue {
  @Prop() private occupationSelection!: GQL_occupationSelections_currentUnit_occupationSelections;

  private DELETE_OCCUPATION_SELECTION = DELETE_OCCUPATION_SELECTION;
  private OCCUPATION_SELECTIONS = OCCUPATION_SELECTIONS;

  private removeFromCache(
    store: InMemoryCache,
    { data: { deleteOccupationSelection: { occupationSelection } } }: IDeleteOccupationResponse,
  ) {
    const data = (store.readQuery({ query: OCCUPATION_SELECTIONS }) as GQL_occupationSelections);
    data.currentUnit.occupationSelections = data.currentUnit.occupationSelections.filter(c => c.id !== occupationSelection.id);
    store.writeQuery({ query: OCCUPATION_SELECTIONS, data });

    try {
      const data = (store.readQuery({ query: ALL_OCCUPATIONS }) as GQL_occupations);
      data.currentUnit.occupations = data.currentUnit.occupations.filter(m => m.id !== occupationSelection.occupation.id);
      store.writeQuery({ query: ALL_OCCUPATIONS, data });
    } catch (e) {}
  }

  private confirmDelete(confirmMutation: () => {}) {
    this.$sPopup.confirm(``, {
      title: this.$t('PopupTitle.confirmDelete'),
      message: this.$t('PopupBody.confirmDelete', { thing: this.occupationSelection.occupation.name }),
      onConfirm: confirmMutation,
    });
  }
}
